import styled from '@emotion/styled'
import Icon from '@mui/material/Icon'
import Typography from '@mui/material/Typography'
import { isEmpty, path } from 'ramda'
import React from 'react'

import CardLayout from '@/app/component/layout/card'
import ErrorLayout from '@/app/component/layout/error'

import type { UploadError } from '../../types'

type Props = {
  error: UploadError
}

const getUploadErrorMessage = (error: UploadError): React.ReactNode => {
  if (typeof error === 'object' && error && 'message' in error) {
    return (error as { message?: React.ReactNode }).message
  }
  return undefined
}

const ContactsUploadSuccessContent: React.FC<Props> = ({ error }) => {
  const hasError = !isEmpty(error)

  return (
    <div>
      {hasError ? (
        <ErrorWrap>
          <CardLayout>
            <ErrorLayout>
              <Typography>{getUploadErrorMessage(error)}</Typography>
            </ErrorLayout>
          </CardLayout>
        </ErrorWrap>
      ) : (
        <SuccessWrap>
          <SuccessIcon>check_circle</SuccessIcon>
          <Typography variant="subtitle1" gutterBottom={true}>
            File uploaded
          </Typography>
          <Typography gutterBottom={true}>{`
              We've started processing your upload. We'll notify you when it's done.
              Please don't leave the engageSPARK website until we notify you that the
              processing has completed.
            `}</Typography>
        </SuccessWrap>
      )}
    </div>
  )
}

const SuccessWrap = styled('div')({
  textAlign: 'center',
})

const SuccessIcon = styled(Icon)((props) => ({
  fontSize: '4rem',
  margin: '2rem 0',
  color: path(['palette', 'success', 'main'], props.theme as any),
}))

const ErrorWrap = styled('div')({
  marginTop: '-2rem',
})

export default ContactsUploadSuccessContent
